export const REGEX = {
  LINK: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/,

  BASE_URL: /^(\/|[a-zA-Z0-9-]+\.[a-zA-Z]{2,}\/?)$/,
  UUID: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/,

  // CHAIN
  ETHEREUM_ADDRESS: /^0x[a-fA-F0-9]{40}$/,
};
